enum BackgroundOverlayTheme {
  AssetExpansion = "asset_expansion",
  Default = "default",
  SensitiveContent = "sensitive_content",
}

export default BackgroundOverlayTheme;
